import { HttpServerInjectable } from '../server/http-server';
const express = require('express');
import { ZetaPushContext } from '@zetapush/core';
import { trace } from '@zetapush/common';
export class ExpressServerConfigurer {
    configure() { }
    async getProviders() {
        return [
            {
                provide: HttpServerInjectable,
                useFactory: (zpContext) => {
                    return new ExpressServerWrapper(express(), zpContext.getLocalZetaPushHttpPort() || 2999);
                },
                deps: [ZetaPushContext]
            }
        ];
    }
}
export class ExpressServerWrapper {
    constructor(app, port) {
        this.app = app;
        this.port = port;
    }
    async onApplicationBootstrap() {
        this.server = this.app.listen(this.port, () => trace(`express server started on port ${this.port}`));
    }
    async onApplicationCleanup() {
        try {
            if (this.server) {
                this.server.close(() => trace(`express server stopped`));
            }
        }
        catch (e) {
            // TODO: logs
            console.warn(`Failed to stop express server`, e);
        }
    }
    use(...args) {
        return this.app.use(...args);
    }
    get(...args) {
        return this.app.get(...args);
    }
    post(...args) {
        return this.app.post(...args);
    }
    head(...args) {
        return this.app.head(...args);
    }
    delete(...args) {
        return this.app.delete(...args);
    }
    put(...args) {
        return this.app.put(...args);
    }
    patch(...args) {
        return this.app.patch(...args);
    }
    options(...args) {
        return this.app.options(...args);
    }
}
//# sourceMappingURL=express.js.map